import { GROUP_SETTINGS_DATA_REQUEST_ASYNC } from 'containers/GroupSettings/Table/constants'
import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'

import { URL_STATE, URL_STATE_CHANGE } from '../List/constants'
import { FETCH_ASSIGNEES_ASYNC } from '../Report/constants'

import {
  getUsesEffectiveIncidentDateFilter,
  LAST_24_HOURS,
  REGULAR_FILTERS_CHANGE,
} from './constants'

const stampedDateFilter = (incidentsRedesignEnabled) =>
  getUsesEffectiveIncidentDateFilter(incidentsRedesignEnabled) ? null : LAST_24_HOURS

export default function () {
  const initialState = {
    // Set when IncidentsRedesign dispatches URL_STATE_CHANGE with incidentsRedesign: true.
    // Lets company-switch / clear-all treat Challenged like the other tabs without reading FF.
    incidentsRedesignEnabled: false,
    regularFilters: {
      detectedByFilter: [],
      includesFilter: [],
      excludesFilter: [],
      assignedToFilter: [],
      resolvedFilter: [],
      themisVerdictFilter: [],
      challengeSourceFilter: [],
      // Legacy Challenged has no date UI — stamp LAST_24_HOURS for count polling.
      // Everywhere else (incidents tabs, Reports, Scan Back) stays null so favorite →
      // company default applies when returning to Unclassified/Classified/Challenged.
      dateFilter: stampedDateFilter(false),
      // Optional [startIso, endIso] for redesign custom time frame → API feDateRange.
      customDateRange: null,
    },
    assignees: [],
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case GROUP_SETTINGS_DATA_REQUEST_ASYNC.SUCCESS:
      case FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS:
        return {
          ...state,
          regularFilters: {
            ...state.regularFilters,
            dateFilter: stampedDateFilter(state.incidentsRedesignEnabled),
            customDateRange: null,
          },
        }
      case URL_STATE_CHANGE: {
        const { urlState, preserveFilters, incidentsRedesign } = action.payload
        const incidentsRedesignEnabled = state.incidentsRedesignEnabled || !!incidentsRedesign
        // First redesign landing on Challenged: drop the legacy LAST_24_HOURS init stamp
        // so favorite → company default applies (same as Unclassified/Classified).
        // Later tab switches keep the user's selected time frame (preserveFilters).
        const dropChallengedLegacyStamp =
          !!incidentsRedesign &&
          urlState === URL_STATE.CHALLENGED &&
          !state.incidentsRedesignEnabled

        // Redesign: keep regularFilters (and custom range) across Unclassified/Classified/Challenged.
        // Legacy still clears chip-backed filters on tab change.
        if (preserveFilters) {
          return {
            ...state,
            incidentsRedesignEnabled,
            regularFilters: dropChallengedLegacyStamp
              ? { ...state.regularFilters, dateFilter: null, customDateRange: null }
              : state.regularFilters,
          }
        }
        if (urlState === URL_STATE.UNCLASSIFIED || urlState === URL_STATE.CLASSIFIED) {
          return {
            ...state,
            incidentsRedesignEnabled,
            regularFilters: {
              dateFilter: state.regularFilters.dateFilter,
              customDateRange: null,
              detectedByFilter: [],
              includesFilter: [],
              excludesFilter: [],
              assignedToFilter: [],
              resolvedFilter: [],
              themisVerdictFilter: [],
              challengeSourceFilter: [],
            },
          }
        }
        return { ...state, incidentsRedesignEnabled }
      }
      case REGULAR_FILTERS_CHANGE:
        if (action.payload.filterType === 'all') {
          return {
            ...state,
            regularFilters: {
              dateFilter: stampedDateFilter(state.incidentsRedesignEnabled),
              customDateRange: null,
              detectedByFilter: [],
              includesFilter: [],
              excludesFilter: [],
              assignedToFilter: [],
              resolvedFilter: [],
              themisVerdictFilter: [],
              challengeSourceFilter: [],
            },
          }
        } else {
          return {
            ...state,
            regularFilters: {
              ...state.regularFilters,
              [action.payload.filterType]: action.payload.value,
            },
          }
        }
      case FETCH_ASSIGNEES_ASYNC.SUCCESS:
        return {
          ...state,
          assignees: Object.values(
            [...state.assignees, ...action.payload.data].reduce((acc, curr) => {
              acc[curr.id] = curr
              return acc
            }, {})
          ),
        }
      default:
        return state
    }
  }
}
